import { InterSvgIcon, WarningMessage } from 'components'
import { Divider, PageContent } from 'common'
import { ProductKeysBrPf } from 'contexts/app-context/types'
import { useManageNotificationsProductNavTic } from 'pages/manage-notifications/hooks/useManageNotificationsProductNavTic'

import { Switch } from '@interco/inter-ui/components/Switch'
import { Text } from '@interco/inter-ui/components/Text'

import {
  TManageNotificationHeader,
  TManageNotificationsView,
} from '../types/ManageNotifications.types'
import {
  DescriptionSection,
  DescriptionSectionBR,
  HeaderSectionContainer,
  ProducsSectionTitle,
  ProductIconAndNameContainer,
  ProductPageLink,
  TitleSectionContainer,
} from '../styles/ManageNotifications.styles'
import { ProductCard } from './productCard/ProductCard'

function DescriptionSectionContent({
  alertSection,
  headerSection,
  descriptionSection,
}: TManageNotificationHeader) {
  const brProductKey = ProductKeysBrPf[0]
  const onBrProductNav = useManageNotificationsProductNavTic(brProductKey)

  if (descriptionSection)
    return (
      <DescriptionSectionBR data-testid="manage-notifications-br-description">
        <Text variant="body-3" color="typography" colorWeight={400} as="p">
          {headerSection.details}
        </Text>
        <ProductPageLink
          key={descriptionSection.name}
          to={brProductKey}
          data-testid="manage-notifications-br-link"
          onClick={onBrProductNav}
        >
          <ProductIconAndNameContainer>
            {descriptionSection.icon && (
              <InterSvgIcon
                width={24}
                height={24}
                iconRef={descriptionSection.icon}
                color="var(--typography500)"
              />
            )}
            <Text variant="body-2" color="typography" colorWeight={500} as="p" bold="true">
              {descriptionSection.name}
            </Text>
          </ProductIconAndNameContainer>
          <InterSvgIcon
            width={24}
            height={24}
            iconRef="core/action-navigation/ic_chevron_right"
            color="var(--secondary500)"
          />
        </ProductPageLink>
      </DescriptionSectionBR>
    )

  return (
    <DescriptionSection data-testid="manage-notifications-description">
      {headerSection.title && (
        <HeaderSectionContainer>
          <TitleSectionContainer>
            <Text variant="headline-h3" color="typography" as="p" semiBold="true">
              {headerSection.title}
            </Text>
            <Switch id="simple" checked disabled />
          </TitleSectionContainer>
          <Text variant="body-3" as="p" color="typography">
            {headerSection.details}
          </Text>
        </HeaderSectionContainer>
      )}
      {alertSection && <WarningMessage {...alertSection} size={16} />}
    </DescriptionSection>
  )
}

function ManageNotificationsView({
  alertSection,
  headerSection,
  descriptionSection,
  isBrazil,
  productMenu,
  title,
}: TManageNotificationsView) {
  return (
    <>
      <DescriptionSectionContent
        headerSection={headerSection}
        alertSection={alertSection}
        descriptionSection={descriptionSection}
      />
      {descriptionSection && <Divider $marginTopPx={6} />}
      <PageContent>
        <ProducsSectionTitle
          variant="body-2"
          color="typography"
          colorWeight={500}
          bold="true"
          as="p"
        >
          {title}
        </ProducsSectionTitle>
        {Object.keys(productMenu).map((key) => {
          const product = productMenu[key as keyof typeof productMenu]
          if (isBrazil && (key === 'TODOS_OS_PRODUTOS' || key === 'TODOS_PRODUTOS')) return null

          return <ProductCard key={key} productKey={key} product={product} isBrazil={isBrazil} />
        })}
      </PageContent>
    </>
  )
}

export { ManageNotificationsView }
